import { TableHead, TableRow, TableCell, IconButton } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import { useChangeAdminStatus, useDeleteAdmin, useGetAdmins } from "./admins";
import { MainTable, BooleanLabel, SelectPopover, TableBody, Pagination, IOSSwitch } from "../../atoms";
import { useNotificationContext } from "../../contexts";
import { DeleteIcon, EditPencilIcon } from "../../icons";
import { useNavigate } from "react-router-dom";
import { dateOnly, dateTime } from "../../helper";

const ListView = ({ filter, handleFilter }) => {
  const { isLoading, data, refetch: refetch } = useGetAdmins(filter);
  const { isLoading: deleting, mutate: deleteAdmin } = useDeleteAdmin();
  const { isLoading: changingStatus, mutate: changeStatus } = useChangeAdminStatus();
  const { confirm } = useNotificationContext();
  const navigate = useNavigate();
  const handlePage = (page: number) => {
    handleFilter({ page });
  };

  const handleChangeStatus = (id: string) => {
    changeStatus(id, {
      onSuccess: () => {
        toast.success("User status changed successfully.");
        refetch();
      },
    });
  };
  const handleDelete = (id: string) => {
    confirm({
      onConfirm: () => {
        deleteAdmin(id, {
          onSuccess: () => {
            toast.success("User deleted successfully.");
            refetch();
          },
        });
      },
    });
  };
  return (
    <>
      <MainTable loading={isLoading || deleting || changingStatus} sx={{ marginTop: "40px" }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Date Added</TableCell>
            <TableCell>Options</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.items.map((item) => (
            <TableRow key={item.id}>
              <TableCell sx={{ minWidth: "20%", whiteSpace: "nowrap" }}>
                {item.firstName} {item.lastName}
              </TableCell>
              <TableCell sx={{ minWidth: "20%" }}>{item.email}</TableCell>
              <TableCell>{item.role}</TableCell>
              <TableCell>{dateTime(item.dateAdded)}</TableCell>

              <TableCell>
                <IconButton onClick={() => handleChangeStatus(item.id)}>
                  <IOSSwitch checked={item.isActive} />
                </IconButton>
                <IconButton
                  onClick={() => {
                    sessionStorage.setItem("ADMIN_DATA", JSON.stringify(item));
                    navigate(":adminId/edit");
                  }}
                >
                  <EditPencilIcon />
                </IconButton>
                <IconButton color="error" onClick={() => handleDelete(item.id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </MainTable>
      <div style={{ marginTop: "1.25rem" }}>
        <Pagination size={filter.size} total={data?.total} page={filter.page} onChange={handlePage} />
      </div>
    </>
  );
};
export default ListView;
